var map = {
	"./backend.png": 1363,
	"./boolBnb.png": 9271,
	"./boolflix.png": 6593,
	"./boolzapp.png": 5850,
	"./dccomics.png": 3134,
	"./oopapi.png": 7332,
	"./playstation.png": 4468,
	"./spotify.png": 950,
	"./springalbum.png": 4782,
	"./springpizzeria.png": 417,
	"./vueproject.png": 8359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4442;